// extracted by css-extract-rspack-plugin
export default {"nav":"rKPE5L","current":"ttmZeP","bg":"Kd_cGO","ray":"vweBom","rect":"V3uq_X","fire":"XAO53i","text":"u_0vrF","main":"JqrgSQ","sub":"kWLC6y","rest":"LwbJTi","item":"J_M82t"};